<template>
    <div class="design-preference-config-select" ref="selectRef" @mousedown="onMouseDown">
        <xl-select
            popper-class="xl-select xl-select--default design-preference-select-option"
            v-bind="$attrs"
        >
            <!-- <xl-option v-for="option in $attrs?.options" :label="option.optionCode" :value="option.optionValue" :key="option.optionValue"></xl-option> -->
        </xl-select>
    </div>
</template>

<script setup>
import { ref, defineProps, useAttrs, defineEmits, onMounted } from 'vue';
import { XlSelect, XlOption } from '@shining3d/ui-components';
// import { onClickOutside } from '@vueuse/core';

const emits = defineEmits(['clickOutside', 'mousedown'])

const $attrs = useAttrs();
const onMouseDown = () => {
    emits('mousedown');
};
// const selectRef = ref();
// const handler = ( ) => {
//     console.log('select outside')
//     emits('clickOutside')
// };

// onClickOutside(selectRef, handler )
</script>
<script>
export default {
    inheritAttrs: false
}
</script>
<style lang="scss">
.design-preference-select-option {
    .el-select-dropdown__item {
        padding-right: 6px !important;
    }
}
</style>